var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.258057 5.19231C0.258057 2.32468 2.58272 0 5.45036 0H33.8596L45.2581 11.3985V46.7308C45.2581 49.5983 42.9333 51.9231 40.0658 51.9231H5.45036C2.58272 51.9231 0.258057 49.5983 0.258057 46.7308V5.19231ZM3.7196 20.7692H14.1042V24.2308H7.18113V34.6154H14.1042V38.0769H3.7196V20.7692ZM27.9504 20.7692H17.5657V31.1538H24.4888V34.6154H17.5657V38.0769H27.9504V27.6923H21.0273V24.2308H27.9504V20.7692ZM34.8734 20.7692H31.4119V33.6015L36.6042 38.7938L41.7965 33.6015V20.7692H38.335V32.1677L36.6042 33.8985L34.8734 32.1677V20.7692Z",
    fill: "#9048FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.1751ff838b1cbf030ea1ea9b58e0a2ac.svg";
export { ForwardRef as ReactComponent };